import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgEditOff = (props) => /* @__PURE__ */ _jsxs("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	width: 18,
	height: 19,
	viewBox: "0 0 18 19",
	fill: "none",
	...props,
	children: [/* @__PURE__ */ _jsx("mask", {
		id: "mask0_2824_38944",
		style: { maskType: "alpha" },
		maskUnits: "userSpaceOnUse",
		x: 0,
		y: 0,
		width: 18,
		height: 19,
		children: /* @__PURE__ */ _jsx("rect", {
			y: .5,
			width: 18,
			height: 18,
			fill: "#D9D9D9"
		})
	}), /* @__PURE__ */ _jsx("g", {
		mask: "url(#mask0_2824_38944)",
		children: /* @__PURE__ */ _jsx("path", {
			d: "M11.3381 9.68899L10.5477 8.89849L12.3736 7.07261L11.4275 6.12649L9.60162 7.95236L8.81112 7.16205L12.518 3.44805C12.6295 3.33655 12.7542 3.25486 12.8922 3.20299C13.0302 3.15099 13.1752 3.12499 13.3271 3.12499C13.4742 3.12499 13.6186 3.15168 13.7604 3.20505C13.9022 3.25843 14.0275 3.3433 14.1361 3.45967L15.0521 4.38705C15.1684 4.49568 15.2514 4.62092 15.3009 4.7628C15.3504 4.90455 15.3751 5.04755 15.3751 5.1918C15.3751 5.33893 15.3491 5.48149 15.2971 5.61949C15.2452 5.75749 15.1636 5.88224 15.0521 5.99374L11.3381 9.68899ZM3.75012 14.75H4.69624L8.67705 10.7692L8.2098 10.2903L7.73093 9.82305L3.75012 13.8039V14.75ZM14.8357 16.9164L9.47899 11.5782L5.16349 15.875H2.62512V13.3481L6.9333 9.03274L1.58374 3.66443L2.38568 2.86249L15.6376 16.1144L14.8357 16.9164ZM8.2098 10.2903L7.73093 9.82305L8.67705 10.7692L8.2098 10.2903Z",
			fill: "#8C8C8C"
		})
	})]
});
export default SvgEditOff;
